import React from 'react';
import { useTranslation } from 'react-i18next';

import { Section, Status, SelectHierarchyLabel } from '@weezevent/nacre';

import { ModerationActions } from '../../../../../../../models';

import { InfoTextTooltip } from '../../../../../../attendee/detail/components/infotext-tooltip/infoTextTooltip';
import LoadingCard from '../../../../../../../components/loadingCard';
import { SelectedAction } from '../../../components';

import css from '../../actions.module.css';

const RevertAction = ({ organizationId, flowId, action, handleAction }) => {
    const { t } = useTranslation();
    const [querySearch, setQuerySearch] = React.useState('');
    const [selectedAction, setSelectionAction] = React.useState(null);

    const [, loadingSelectedAction] = ModerationActions.useApiModel(
        {
            organizationId,
            flowId,
            id: action.action,
            launch: Boolean(action.action),
            cache: false,
            allow_cache: false,
            onSuccess: resp => {
                setSelectionAction(resp);
            }
        },
        [flowId, organizationId, action.action]
    );

    const [actions, loadingActions] = ModerationActions.useApiModel(
        {
            organizationId,
            flowId,
            cache: false,
            allow_cache: false,
            query: {
                search: querySearch
            }
        },
        [flowId, organizationId, querySearch]
    );

    const placeHolder = React.useMemo(() => {
        if (!selectedAction) {
            return t('ticket.moderation.statusesTransitions.transition.steps.actions.selectAction');
        }
        return t(`ticket.moderation.statusesTransitions.transition.steps.actions.${selectedAction?.type}`);
    }, [selectedAction]);

    const handleDelete = React.useCallback(() => {
        handleAction('action', null);
        setSelectionAction(null);
    }, [handleAction]);

    const actionsOptions = React.useCallback(
        (actions = []) => {
            if (loadingActions || !actions) {
                return [];
            }

            let filteredActions = actions.filter(ac => ac.allow_revert);

            if (action.id) {
                filteredActions = filteredActions.filter(ac => ac.id !== action.id);
            }

            return filteredActions?.map(act => ({
                key: act.id,
                text: (
                    <div className={css['action-select-options']}>
                        <InfoTextTooltip
                            title={act.name}
                            subtitle={
                                <span>
                                    {`${t('ticket.common.type')}: `}
                                    {t(`ticket.moderation.statusesTransitions.transition.steps.actions.${act.type}`)}
                                </span>
                            }
                        />
                        <div>
                            <Status responsive text={t(`ticket.moderation.statusesTransitions.actionsTable.status_${act.status}`)} color={act.status_color} />
                        </div>
                    </div>
                ),
                value: act.id
            }));
        },
        [loadingActions]
    );

    return (
        <>
            <div className={css['selector-container']}>
                <SelectHierarchyLabel
                    height="medium"
                    placeholder={placeHolder}
                    selected={selectedAction}
                    searchValue={querySearch}
                    onExternalSearch={setQuerySearch}
                    options={actionsOptions(actions)}
                    externalOptions={actionsOptions(actions)}
                    placeholderSearch={t('ticket.common.action.search')}
                    onChange={(_, { value }) => handleAction('action', value)}
                    label={t('ticket.moderation.statusesTransitions.transition.steps.actions.revertActionLabel')}
                />
            </div>

            {selectedAction && (
                <Section className={css['action-section']}>
                    <LoadingCard loading={loadingSelectedAction}>
                        <SelectedAction action={selectedAction} status={false} handleDelete={handleDelete} />
                    </LoadingCard>
                </Section>
            )}
        </>
    );
};

export default RevertAction;
